<template>
  <div
    class="c-volume h-100 w-100"
    :style="{
      background: 'linear-gradient(' + angle + 'deg, ' + barColor + gradient + '%, transparent 0%) !important'
    }"
  >
    <span class="volume-value">
      <v-fidlet :data="value || ''" type="int" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'c-volume',
  props: {
    volume: {
      type: Object,
      required: true
    }
  },
  computed: {
    value() {
      return this.volume.value;
    },
    gradient() {
      return this.volume.pct;
    },
    angle() {
      return this.volume.direction === 'rightJustified' ? -90 : 90;
    },
    barColor() {
      if (this.volume.barColor) {
        return this.volume.barColor;
      } else return `rgba(250, 250, 250, .3)`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-volume';
</style>
